import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import * as reportActions from "../../slices/report/getReportSkuActualDeliveryMonthly.slice";
import { endPoint } from "constants/server/api";
import { http } from "utils/http";
var requestReportSkuActualDeliveryMonthly = function(url) {
    return function(payload, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        return function() {
            var _ref = _async_to_generator(function(dispatch) {
                var result, error, _error_response, _error_response_data, _error_response1, statusCode;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            dispatch(reportActions.fetchData());
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                http({
                                    method: "post",
                                    headers: {
                                        Authorization: "Bearer ".concat(localStorage.getItem("accessToken"))
                                    },
                                    url: url,
                                    data: payload
                                })
                            ];
                        case 2:
                            result = _state.sent();
                            dispatch(reportActions.fetchDataSuccess(result.data));
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            statusCode = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) || 500;
                            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                                visible: true,
                                subTitle: "รหัส ".concat(statusCode),
                                navigateDirection: undefined,
                                title: (error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data = _error_response1.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || "เกิดข้อผิดพลาด หรือเครือข่ายขัดข้อง"
                            }));
                            dispatch(reportActions.fetchDataFailure());
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(dispatch) {
                return _ref.apply(this, arguments);
            };
        }();
    };
};
export var getReportSkuActualDeliveryMonthly = requestReportSkuActualDeliveryMonthly(endPoint.REPORT_SKU_ACTUAL_DELIVERY_MONTHLY);
export var getReportSkuGiftMonthly = requestReportSkuActualDeliveryMonthly(endPoint.REPORT_SKU_GIFT_MONTHLY);
export var getReportSkuActualDeliveryMonthlyByShop = requestReportSkuActualDeliveryMonthly(endPoint.REPORT_SKU_ACTUAL_DELIVERY_MONTHLY_BY_SHOP);
export var clearGetReportSkuActualDeliveryMonthly = function() {
    return function(dispatch) {
        dispatch(reportActions.resetState());
    };
};
